import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';

import users from './modules/users';
import classes from './modules/classes';
import students from './modules/students';
import exercises from './modules/exercises';
import assignments from './modules/assignments';
import settings from './modules/settings';
import toasts from './modules/toasts';
import purchase from './modules/purchase';
import teachbot from './modules/teachbot';
import favourites from './modules/favourites';
import device from './modules/device';
import aiLesson from './modules/aiLesson';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;

const store = new Vuex.Store({
  state: {
    authToken: undefined,
    userToken: undefined
  },
  mutations: {
    storeToken(state, token) {
      state.authToken = token;
      window.$cookies.set('x-classroom-token', token, null, null, cookieDomain);
    },
    removeXTokenFromCookie() {
      window.$cookies.set('x-classroom-token', undefined, null, null, cookieDomain);
      document.cookie =
        `x-classroom-token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=${cookieDomain};path=/`;
    },
    storeUserToken(state, token) {
      state.userToken = token;
    }
  },
  getters: {
    hasToken: state => (state.authToken !== undefined && state.authToken !== null && state.authToken !== ''),
    authToken: state => state.authToken,
    userToken: state => state.userToken
  },
  modules: {
    users,
    classes,
    students,
    exercises,
    assignments,
    settings,
    toasts,
    purchase,
    teachbot,
    favourites,
    device,
    aiLesson
  },
  strict: debug,
  plugins: [persistedState({
    key: 'store',
    paths: [
      'authToken',
      'settings.learnedLanguage',
      'settings.backRoute',
      'settings.lastClassesPath',
      'settings.appleDetails',
      'settings.siteLanguage',
      'settings.userIsLoggedIn',
      'settings.sessionExpired',
      // 'settings.forceWebViewStatus',
      'settings.dktDeeplinkParams',
      'device',
      'userToken',
      'users.loggedInUserProfile',
      'settings.handledUnauthorizedError',
      'settings.guestLink',
      'settings.guestError',
      'settings.appBannerVisible',
      'settings.narratorLanguage',
      'settings.wcag'
    ]
  })]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js